/*************************************************/
/* ACCORDION                                     */
/*************************************************/
import customEventsNames from './../customEventsNames';

export function accordion() {
    const accordionParentSelector = '.accordion';
    const accordionItemSelector = '.accordion__item';
    const accordionItemToggleSelector = '.accordion__item-head';
    const accordionItemContentSelector = '.accordion__item-content';
    const accordionItemActiveClass = 'accordion__item--active';
    const accordionIdDataAttributeName = 'data-accordion-id';
    const accordionItemIdDataAttributeName = 'data-accordion-item-id';
    const imageAccordionSelector = '.image-accordion';
    const imageAccordionContainerSelector = '.image-accordion__images-container';

    const getTargetedAccordionItem = (accordionElement, accordionItemId) => {
        return accordionElement.querySelector(
            `[${accordionItemIdDataAttributeName}="${accordionItemId}"]`
        );
    };

    const setActiveStylesOnAccordionItem = (accordionItem) => {
        if (accordionItem != null) {
            const accordionItemContent = accordionItem.querySelector(accordionItemContentSelector);
            accordionItemContent.style.maxHeight = `${accordionItemContent.scrollHeight}px`;
            accordionItemContent.setAttribute('aria-hidden', false);
            accordionItem.classList.add(accordionItemActiveClass);
            accordionItem.setAttribute('aria-expanded', true);
        }
    };

    const setInactiveStylesOnAccordionItem = (accordionItem) => {
        if (accordionItem != null) {
            const accordionItemContent = accordionItem.querySelector(accordionItemContentSelector);
            accordionItemContent.style.maxHeight = "0px";
            accordionItemContent.setAttribute('aria-hidden', true);
            accordionItem.classList.remove(accordionItemActiveClass);
            accordionItem.setAttribute('aria-expanded', false);
        }
    };

    const init = () => {
        const accordions = document.querySelectorAll(accordionParentSelector);
        if (accordions.length > 0) {
            accordions.forEach(accordionElement => {
                const accordionId = accordionElement.getAttribute(accordionIdDataAttributeName);

                accordionElement.addEventListener(customEventsNames.accordionActivateItemEventName, e => {
                    if (e.detail.accordionId !== accordionId) return; // Only handle event for this instance

                    const targetedAccordionItem = getTargetedAccordionItem(accordionElement, e.detail.accordionItemId);
                    if (targetedAccordionItem) {
                        // Deactivate all items in this accordion first
                        accordionElement.querySelectorAll(accordionItemSelector).forEach(setInactiveStylesOnAccordionItem);
                        // Then activate the targeted one
                        setActiveStylesOnAccordionItem(targetedAccordionItem);
                    }
                });

                accordionElement.addEventListener(customEventsNames.accordionDeactivateItemEventName, e => {
                    if (e.detail.accordionId !== accordionId) return;
                    const targetedAccordionItem = getTargetedAccordionItem(accordionElement, e.detail.accordionItemId);
                    if (targetedAccordionItem) {
                        setInactiveStylesOnAccordionItem(targetedAccordionItem);
                    }
                });

                accordionElement.addEventListener(customEventsNames.accordionDeactivateAllItemsEventName, e => {
                    if (e.detail.accordionId !== accordionId) return;
                    accordionElement.querySelectorAll(accordionItemSelector).forEach(setInactiveStylesOnAccordionItem);
                });

                accordionElement.querySelectorAll(accordionItemToggleSelector).forEach(toggleElement => {
                    toggleElement.addEventListener('click', e => {
                        const clickedAccordionItem = e.target.closest(accordionItemSelector);
                        const itemId = clickedAccordionItem.getAttribute(accordionItemIdDataAttributeName);
                        const itemIndex = clickedAccordionItem.dataset.accordionItemIndex;

                        if (clickedAccordionItem.classList.contains(accordionItemActiveClass)) {
                            const deactivateEvent = new CustomEvent(customEventsNames.accordionDeactivateItemEventName, {
                                detail: { accordionId, accordionItemId: itemId }
                            });
                            accordionElement.dispatchEvent(deactivateEvent);
                        } else {
                            const activateEvent = new CustomEvent(customEventsNames.accordionActivateItemEventName, {
                                detail: { accordionId, accordionItemId: itemId, accordionItemIndex: itemIndex }
                            });
                            accordionElement.dispatchEvent(activateEvent);

                            const imageAccordionParent = clickedAccordionItem.closest(imageAccordionSelector);
                            if (imageAccordionParent) {
                                const imageContainer = imageAccordionParent.querySelector(imageAccordionContainerSelector);
                                if (imageContainer) {
                                    imageContainer.dispatchEvent(activateEvent);
                                }
                            }
                        }
                    });
                });

                // Initialize active item
                const initiallyActiveItem = accordionElement.querySelector(`.${accordionItemActiveClass}`);
                if (initiallyActiveItem) {
                    setActiveStylesOnAccordionItem(initiallyActiveItem);
                }

                const initializedEvent = new CustomEvent(customEventsNames.accordionInitialised, {});
                accordionElement.dispatchEvent(initializedEvent);
            });
        }
    };

    init();
}
